
<section class="py-4">
  <div class="row mx-2">
    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="laudoid">ID Laudo</label>
      <input
        [formControl]="form.controls.id"
        id="laudoid"
        type="number"
        class="form-control"
      />
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="placa">Placa</label>
      <input
        [formControl]="form.controls.placa"
        [textMask]="masks.placa"
        id="placa"
        class="form-control"
      />
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="nomeusuario">Vistoriador</label>
      <input
        [formControl]="form.controls.nomeusuario"
        id="nomeusuario"
        type="text"
        class="form-control"
      />
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="tipolaudo">Tipo de laudo</label>
      <select
        [formControl]="form.controls.tipolaudo"
        id="tipolaudo"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaTipoLaudo" [value]="o.id">
          {{ o.nome }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="cliente">Cliente</label>
      <select
        [formControl]="form.controls.cliente"
        id="cliente"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaClientes" [value]="o.id">
          {{ o.nomefantasia }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="unidade">Unidade</label>
      <select
        [formControl]="form.controls.unidade"
        id="unidade"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaUnidades" [value]="o.id">
          {{ o.nomefantasia }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <app-date-interval
        [(inicio)]="params.filter.dataInicio"
        [(fim)]="params.filter.dataFim"
        (fimChange)="updateResult()"
        (inicioChange)="updateResult()"
      ></app-date-interval>
    </div>


    <div class="w-100 px-3 pt-3 row">
      <div class="btn-group col-12">
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '' }"
          (click)="setSituacaoLaudo('')"
          class="btn"
        >
          Todos
        </button>
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '2' }"
          (click)="setSituacaoLaudo('2')"
          class="btn"
        >
          Agendados
        </button>
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '3' }"
          (click)="setSituacaoLaudo('3')"
          class="btn"
        >
          Cancelados
        </button>
      </div>
      <div class="text-right col-12 mt-3">
        Foram encontrados {{ total }} registro(s).
      </div>
      <div class="text-right col-12 mt-3">
        <a
      [routerLink]="['/laudo', 'agendamento','adicionar']"
      rel="noopener noreferrer"
      class="btn btn-sm btn-success mt-3">
      <i class="mdi mdi-plus">
      </i> Novo agendamento
       </a>
      </div>


    </div>
  </div>

  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div
      *ngIf="tableLoading"
      class="p-5 d-flex justify-content-center position-relative"
    >
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Marca</th>
            <th>Id</th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nometipolaudo"
              (tableOrderChange)="changeOrder()"
            >
              Tipo Laudo
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomecliente"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Cliente
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomeunidade"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Unidade
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomeusuario"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Vistoriador
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.placa"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Placa
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.dataagendamento"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Agendado para
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.local"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Local
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.dataultimaatualizacao"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Atualizado em
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.status"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Status
            </th>
            <th>
              <button class="btn btn-sm btn-success" (click)="downloadExcel()">
                <i class="mdi mdi-download"></i> Download Excel
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="listaResultado.length == 0">
            <td class="text-center py-5 text-secondary w-500" colspan="11">
              Sem registros
            </td>
          </tr>
          <tr *ngFor="let r of listaResultado">
            <td>
              <img
                width="30px"
                src="assets/images/marcas/{{ r.fabricante }}.png"
                alt=""
              />
            </td>
            <td>{{ r.id }}</td>
            <td>{{ r.nometipolaudo }}</td>
            <td>{{ r.nomecliente || "PARTICULAR" }}</td>
            <td>{{ r.nomeunidade }}</td>
            <td>
              <div class="vistoriador">
                {{ r.nomeusuario }}
                <div *ngIf="r.status == 2">
                  <button *ngIf="
                  usuario.permissoes.administrador ||
                  usuario.permissoes.usuario_analista"
                  class="editarVistoriador"
                  (click)="editarVistoriador(r.unidadeid, r.id, r.placa)">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                </div>
              </div>
            </td>
            <td>{{ r.placa }}</td>
            <td>
              <div class="vistoriador">
                <div class = "col">
                  <div class = "data">
                    {{ r.dataagendamento | date: "dd/MM/yyyy" }}
                  </div>
                  <div class="periodo">
                    {{r.periodoagendamento == 0 ? "Manhã" : "Tarde"}}
                  </div>
                </div>
                <div *ngIf="r.status == 2">
                  <button *ngIf="
                  usuario.permissoes.administrador ||
                  usuario.permissoes.usuario_analista
                " class="editarVistoriador" (click)="editarDataAgendamento(r.id, r.placa)">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                </div>
              </div>
            </td>
            <td>
              <div class="col">
                <div class="endereco">
                  {{r.bairro}}
                  {{r.cidade + "/" + r.uf}}
                </div>
                <a class="verEndereco" (click)="verEndereco(r.cidade, r.uf, r.bairro, r.rua, r.numero, r.cep)">ver completo</a>
              </div>
            </td>
            <td>{{ r.dataultimaatualizacao | date: "dd/MM/yyyy HH:mm" }}</td>
            <td>
              {{ r.status == 0 ? "EM ANDAMENTO" : "" }}
              {{ r.status == 1 ? "FINALIZADO" : "" }}
              {{ r.status == 2 ? "AGENDADO " : ""}}
              {{ r.status == 3 ? "CANCELADO" : ""}}
              <strong *ngIf="r.statusagendamento == 0 && r.status == 2" class="statusAgendamento" style="background-color: #ffff00a6;">{{ r.statusagendamento == 0 ? "pendente" : ""}}</strong>
              <strong *ngIf="r.statusagendamento == 1 && r.status == 2" class="statusAgendamento" style="background-color: #00d10080;">{{r.statusagendamento == 1 ? "confirmado" : ""}}</strong>
              <strong *ngIf="r.statusagendamento == 2 && r.status == 2" class="statusAgendamento" style="background-color: #fd3c3c7a;">{{r.statusagendamento == 2 ? "rejeitado" : ""}}</strong>
            </td>
            <td class="py-1">
              <div class="d-flex align-items-center justify-content-end">
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Visualizar laudo"
                >
                  <a
                    [routerLink]="['/laudo', 'visualizar', r.tokenlaudo]"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="btn btn-sm btn-info btn-icon mr-1"
                  >
                    <i class="mdi mdi-eye"></i>
                  </a>
                </span>
                <span *ngIf="r.status == 2"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Cancelar agendamento"
                >
                  <a
                    (click)="cancelarAgendamento(r.id, r.placa)"
                    style="color:white; padding: 0%; font-weight: bold;"
                    rel="noopener noreferrer"
                    class="btn btn-sm btn-danger btn-icon"
                    *ngIf="
                      usuario.permissoes.administrador ||
                      usuario.permissoes.usuario_analista"
                  >
                  <i class="mdi mdi-table-off"></i>
                  </a>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer bg-white row justify-content-between">
      <div class="pb-2 pb-sm-0">
        <ngb-pagination
          [pageSize]="params.per_page"
          [boundaryLinks]="true"
          [collectionSize]="total"
          [(page)]="params.page"
          (pageChange)="nextPage()"
          [maxSize]="5"
          [rotate]="true"
        >
        </ngb-pagination>
      </div>
      <div class="pb-2 pb-sm-0">
        <div class="btn-group" role="group">
          <button
            [disabled]="total == 0"
            (click)="setPageSize(10)"
            [ngClass]="{ active: params.per_page == 10 }"
            type="button"
            class="btn btn-outline-primary"
          >
            10
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(25)"
            [ngClass]="{ active: params.per_page == 25 }"
            type="button"
            class="btn btn-outline-primary"
          >
            25
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(50)"
            [ngClass]="{ active: params.per_page == 50 }"
            type="button"
            class="btn btn-outline-primary"
          >
            50
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(100)"
            [ngClass]="{ active: params.per_page == 100 }"
            type="button"
            class="btn btn-outline-primary"
          >
            100
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
